import { Button, Notice, OctagonAlertIcon } from '@buffer-mono/popcorn'

import { getChannelName } from '~publish/helpers/channels'
import { FeedRow } from '~publish/pages/Community/components/FeedRow'

import type { Channel } from '../CommunityConfig'

import type { JSX } from 'react'

const SUPPORT_URL = 'https://support.buffer.com'

function openSupportChat(): void {
  if (window.Beacon) {
    window.Beacon('open')
  } else {
    window.open(SUPPORT_URL, '_blank', 'noopener,noreferrer')
  }
}

type ChannelRefreshUnsuccessfulNoticeProps = {
  channelsWithFailedRefresh: Channel[]
}

export function ChannelRefreshUnsuccessfulNotice({
  channelsWithFailedRefresh,
}: ChannelRefreshUnsuccessfulNoticeProps): JSX.Element {
  if (channelsWithFailedRefresh.length === 1) {
    const channel = channelsWithFailedRefresh[0]
    const channelName =
      ('name' in channel ? channel.name : undefined) ??
      ('displayName' in channel ? channel.displayName : undefined)
    const serviceLabel = getChannelName(channel.service)

    return (
      <FeedRow>
        <Notice variant="error" icon={<OctagonAlertIcon />}>
          <Notice.Heading>
            We couldn&apos;t refresh your {channelName} {serviceLabel} channel
            connection
          </Notice.Heading>
          <Notice.Text>
            Our Support Team can help you fix this issue.
          </Notice.Text>
          <Notice.Actions>
            <Button variant="critical" size="small" onClick={openSupportChat}>
              Contact Support
            </Button>
          </Notice.Actions>
        </Notice>
      </FeedRow>
    )
  }

  return (
    <FeedRow>
      <Notice variant="error" icon={<OctagonAlertIcon />}>
        <Notice.Heading>
          We couldn&apos;t refresh some of your channel connections
        </Notice.Heading>
        <Notice.Text>Our Support Team can help you fix this issue.</Notice.Text>
        <Notice.Actions>
          <Button variant="critical" size="small" onClick={openSupportChat}>
            Contact Support
          </Button>
        </Notice.Actions>
      </Notice>
    </FeedRow>
  )
}
